import React from 'react';
import { Modal, View, Text, Pressable, StyleSheet, Linking } from 'react-native';
import { Citation } from '../../services/chatApi';
import { useTheme } from '../../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';

export function CitationModal({
  visible,
  onClose,
  citation,
}: {
  visible: boolean;
  onClose: () => void;
  citation: Citation;
}) {
  const { theme } = useTheme();
  const { t } = useTranslation();

  const canOpen = citation.linked && !!citation.uri;

  const handleOpen = () => {
    if (canOpen) Linking.openURL(citation.uri as string);
    onClose();
  };

  return (
    <Modal visible={visible} animationType="slide" transparent>
      <View style={styles.backdrop}>
        <View style={[styles.card, { backgroundColor: theme.colors.surface }]}>
          <Text style={[styles.title, { color: theme.colors.text }]}>{citation.label}</Text>
          {canOpen && (
            <Text style={[styles.uri, { color: theme.colors.textSecondary }]}>{citation.uri}</Text>
          )}
          <View style={styles.row}>
            {canOpen && (
              <Pressable
                onPress={handleOpen}
                style={[styles.btn, { backgroundColor: theme.colors.primary }]}
              >
                <Text style={{ color: theme.colors.textInverse }}>
                  {t('chat.openSource', { defaultValue: 'Open source' })}
                </Text>
              </Pressable>
            )}
            <Pressable
              onPress={onClose}
              style={[styles.btn, { backgroundColor: theme.colors.surfaceSecondary }]}
            >
              <Text style={{ color: theme.colors.text }}>
                {t('common.close', { defaultValue: 'Close' })}
              </Text>
            </Pressable>
          </View>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: { flex: 1, justifyContent: 'flex-end', backgroundColor: 'rgba(0,0,0,0.4)' },
  card: { padding: 16, borderTopLeftRadius: 16, borderTopRightRadius: 16, maxHeight: '60%' },
  title: { fontSize: 18, fontWeight: '600', marginBottom: 4 },
  uri: { fontSize: 12, marginBottom: 12 },
  row: { flexDirection: 'row', gap: 8, marginTop: 8 },
  btn: { padding: 12, borderRadius: 8, flex: 1, alignItems: 'center' },
});
